import OutputDisplay from "./outputDisplay";

export default OutputDisplay;
